export const LABELS = {
    
    additionalAction: 'פעולות נוספות',
    btnDownloadDoc: 'הורדת המסמך',
    downLoadErrorMsg: 'הורדת הקובץ נכשלה. אנו מתנצלים על אי הנוחות',
    mapHeader: 'מפת רישיונות בקלסר'
}